import { useQuery } from '../models/reactUtils'
import { observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Fab from '@mui/material/Fab'

export const AppointmentButton = observer(({ location, provider, sx }) => {
  const { store } = useQuery()
  const { t } = useTranslation()
  const buttonText = () => {
    switch (location?.bookingExperience) {
      case 'dolphin':
      case 'schedule_connect':
      case 'manual':
        return t('Book Online')
      case 'intelibly_direct':
        return t('Request Appointment')
      default:
        return null
    }
  }
  const onClickHandler = () => {
    if (provider && provider.id) {
      store.openProviderLocation(provider.id, location.id)
    } else {
      store.openPracticeLocation(location.practice.id, location.id)
    }
  }

  return (
    <Fab
      aria-label="Appointment Button"
      size="small"
      variant="extended"
      sx={{
        my: 1,
        width: 1,
        height: { xs: 44, md: 40 },
        minHeight: { xs: 44, md: 40 },
        borderRadius: '24px',
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        border: 0,
        boxShadow: 'none',
        fontFamily: 'Qanelas, Arial, sans-serif',
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 500,
        letterSpacing: 0,
        '&:hover': { bgcolor: 'primary.dark', boxShadow: 'none' },
        ...sx,
      }}
      onClick={onClickHandler}
    >
      {buttonText()}
    </Fab>
  )
})
